import httpClient from './httpClient';

// Types for the peer-comparison (anonymous org-wide ranking) API.
// See ranking_implementation.md for the full spec.

export interface ScoreComparison {
  available: boolean;
  reason?: string;
  your_score?: number;
  better_than_percent?: number | null;
  rank?: number | null;
  peers_in_bucket?: number;
  session_count?: number;
  message?: string | null;
}

export interface Consistency {
  current_streak_days?: number;
  longest_streak_days?: number;
  practice_days_in_window?: number;
  better_than_percent?: number | null;
  streak_better_than_percent?: number | null;
  consistency_better_than_percent?: number | null;
  org_median_streak?: number;
  message?: string | null;
}

export interface EngagementSkill {
  name: string;
  better_than_percent?: number | null;
}

export interface EngagementGrowthArea {
  name: string;
  gap_vs_org_avg?: number;
}

export interface Engagement {
  practice_volume_percentile?: number | null;
  skills_breadth_percentile?: number | null;
  strongest_skill?: EngagementSkill;
  growth_area?: EngagementGrowthArea;
  readiness_tier?: string;
}

export interface ScoreComparisons {
  overall?: ScoreComparison;
  coding?: ScoreComparison;
  technical?: ScoreComparison;
  gd?: ScoreComparison;
}

export interface PeerComparisonResponse {
  student_id?: string;
  org_id?: string;
  rankings_computed_at?: string | null;
  cohort_size?: number;
  score_comparisons?: ScoreComparisons;
  consistency?: Consistency;
  engagement?: Engagement;
  rankings_pending?: boolean;
  reason?: string;
}

// API functions
export const rankingApi = {
  /**
   * Get the logged-in student's anonymous org-wide peer comparison.
   * GET /api/orchestrator/analytics/peer-comparison
   */
  async getPeerComparison(): Promise<PeerComparisonResponse> {
    const response = await httpClient.get<PeerComparisonResponse>(
      'orchestrator/analytics/peer-comparison'
    );
    return response.data;
  },
};

export const getPeerComparison = (): Promise<PeerComparisonResponse> =>
  rankingApi.getPeerComparison();

export default rankingApi;
